const STORAGE_KEY = 'avziCartCountdownDeadline';
const DEFAULT_MINUTES = 10;

function readDeadline() {
  try {
    const value = Number(window.localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(value) ? value : 0;
  } catch (_) {
    return 0;
  }
}

function writeDeadline(value) {
  try {
    if (value > 0) {
      window.localStorage.setItem(STORAGE_KEY, String(value));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (_) {
    // The timer still works for the current page when storage is unavailable.
  }
}

function getDurationMs(element) {
  const globalMinutes = document.documentElement.dataset.avziCartCountdownMinutes;
  const minutes = Number(element?.dataset.durationMinutes || globalMinutes || DEFAULT_MINUTES);
  return Math.max(1, Number.isFinite(minutes) ? minutes : DEFAULT_MINUTES) * 60 * 1000;
}

function startNewDeadline(durationMs) {
  const deadline = Date.now() + durationMs;
  writeDeadline(deadline);
  document.dispatchEvent(new CustomEvent('avzi:cart-countdown-reset', { detail: { deadline } }));
  return deadline;
}

class CartReserveTimer extends HTMLElement {
  intervalId = 0;
  deadline = 0;

  connectedCallback() {
    this.timeElement = this.querySelector('[data-cart-reserve-time]');
    if (!this.timeElement) return;

    const storedDeadline = readDeadline();
    this.deadline = storedDeadline > 0 ? storedDeadline : startNewDeadline(getDurationMs(this));

    this.handleReset = (event) => {
      this.deadline = Number(event.detail?.deadline) || startNewDeadline(getDurationMs(this));
      this.render();
    };

    document.addEventListener('avzi:cart-countdown-reset', this.handleReset);
    this.render();
    this.intervalId = window.setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.intervalId);
    document.removeEventListener('avzi:cart-countdown-reset', this.handleReset);
  }

  render() {
    if (!this.timeElement) return;

    const remaining = Math.max(0, this.deadline - Date.now());
    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    this.timeElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    this.toggleAttribute('expired', remaining <= 0);

    if (remaining <= 0) {
      window.clearInterval(this.intervalId);
      this.timeElement.textContent = '00:00';
    }
  }
}

if (!customElements.get('cart-reserve-timer')) {
  customElements.define('cart-reserve-timer', CartReserveTimer);
}

// The theme uses the same cart:update event for add, quantity, and remove actions.
document.addEventListener('cart:update', (event) => {
  const itemCount = Number(event.detail?.resource?.item_count);
  const source = event.detail?.data?.source;
  const didError = event.detail?.data?.didError;

  if (Number.isFinite(itemCount) && itemCount <= 0) {
    writeDeadline(0);
    return;
  }

  if (source === 'product-form-component' && !didError) {
    const timer = document.querySelector('cart-reserve-timer');
    startNewDeadline(getDurationMs(timer));
  }
});
